<template>
  <div v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper">
      <div class="container">
        <article>
          <div class="step-bar-container">
            <ul>
              <li class="li-step">
                <span class="stepnum num01"></span>
                <span class="steptext">条件入力</span>
              </li>
              <li class="li-step active">
                <span class="stepnum num02"></span>
                <span class="steptext">見積り確認</span>
              </li>
              <li class="li-step">
                <span class="stepnum num03"></span>
                <span class="steptext">連絡先入力</span>
              </li>
              <li class="li-step">
                <span class="stepnum num04"></span>
                <span class="steptext">最終確認</span>
              </li>
            </ul>
          </div>
          <section class="section half-circle">
            <div class="half-circle-top">
              <img src="lib/images/ic_car.svg" alt="" class="half-circle-top-icon">
            </div>
            <p class="text-center mt20 mb4 fs15 car-type-text">{{ Manufacturer.manufacturer_name }} {{firstRegistrationOnWareki.gengo}}{{firstRegistrationOnWareki.year}}年{{firstRegistrationOnWareki.month}}月登録</p>
            <h2 class="text-center fs16 font-weight-bold">お見積り金額(税込)</h2>
            <p class="text-center fs44 font-weight-bold">{{ $filters.addComma(price.total) }}<span class="ml4 fs20 va-middle">円</span></p>
            <hr class="hr-solid-gray mt16 mb16">
            <dl class="dl estimate-result-list mb12">
              <dt>法定費用</dt>
              <dd class="mb4">{{ $filters.addComma(price.legal_fee.subtotal) }}円</dd>
              <dt>車検基本料+定額整備費用</dt>
              <dd class="mb4">{{ $filters.addComma(price.price.subtotal) }}円</dd>
              <div v-if="price.coupon_fee !== null">
                <dt>クーポン</dt>
                <dd class="mb4 color-red2">{{ $filters.addComma(price.coupon_fee) }}円</dd>
              </div>
              <dt>（うち消費税</dt>
              <dd class="mb4">{{ $filters.addComma($filters.roundDown(taxPrice)) }}円）</dd>
            </dl>
            <div class="bg-gray1 pd12">
              <p class="mb0 color-font2">※エコカーのお客様の場合、エコカー減税の適用により車検費用が変わる可能性があります。</p>
              <p class="mb0 color-font2">※バンパー、ドアミラー、フロントガラスなど定額対象外の整備が発生し追加の整備費用がかかることがあります。定額整備部品の一覧や交換基準については<a href="#" v-on:click="toAgreement()">こちら</a>を御覧ください</p>
            </div>
              <button class="button button-gray fs16 mt20 mb12 w85p" v-on:click="toEstimateDetail()">見積り詳細</button>
            <div v-if="expiryOnDate < sixMonthLater">
              <router-link :to="{ name: 'PreferredDate', params: {
              price:price,
              car:$route.params.car,
              expiryOnWareki:expiryOnWareki,
              firstRegistrationOnWareki:firstRegistrationOnWareki,
              Manufacturer:Manufacturer,
              carType:carType,
              nativeData:$route.params.nativeData,
              tsId:this.$route.params.tsId,
              ssInfo:this.$route.params.ssInfo,
              profileInfo:this.$route.params.profileInfo
              }}" style="text-decoration: none;"
              v-on:click.native="eventTrackStartPreferred()"
              >
                <button class="button fs16 mb12 w85p">次へ</button>
              </router-link>
            </div>
            <div v-else>
              <p class="fs13 font-weight-bold color-font2 text-center mb4">車検まで半年を切るとSSに予約できます</p>
              <button class="button fs16 mb12 w85p" disabled>次へ</button>
            </div>
          </section>
          <Lease v-bind:car="$route.params.car" v-bind:popInfoNo="$route.params.nativeData.popinfoid" v-bind:transitionFrom="'fromEstimate'"></Lease>
        </article>
      </div>
    </div>
    <router-link :to="{ name: 'Car', params: { nativeData:this.$route.params.nativeData, tsId:this.$route.params.tsId, ssInfo:this.$route.params.ssInfo, profileInfo:this.$route.params.profileInfo }}">
      <button id="isInitial" class="button fs16 mb20 pd16 w80p" style="display: none;"></button>
    </router-link>

  </div>
  <div v-else-if="isEstimateDetail">
    <a id="isEstimateDetail" v-on:click="toInitial()"></a>
    <EstimateDetailBefore v-bind:car="$route.params.car" v-bind:price="price" v-bind:expiryOnWareki="expiryOnWareki" v-bind:firstRegistrationOnWareki="firstRegistrationOnWareki" v-bind:Manufacturer="Manufacturer" v-bind:carType="carType"></EstimateDetailBefore>
  </div>
  <div v-else-if="isAgreement">
    <a id="isAgreement" v-on:click="toInitial()"></a>
    <Agreement></Agreement>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EstimateDetailBefore from '@/views/EstimateDetailBefore.vue'
import price from '../store/Api/price'
import carTypeApi from '../store/Api/cartype'
import manufacturersApi from '../store/Api/manufacturers'
import Lease from '@/views/Lease.vue'
import Agreement from '@/views/Agreement.vue'
import moment from 'moment'
import Loading from '@/views/Loading.vue'
import modal from '../assets/modal'

const IS_INITIAL = 'IS_INITIAL'
const IS_ESTIMATE_DETAIL = 'IS_ESTIMATE_DETAIL'
const IS_AGREEMENT = 'IS_AGREEMENT'

export default {
  methods: {
    ...mapActions('PRICE', [
      'setPrice'
    ]),
    dateParse (date) {
      const year = Number(date.substr(0, 4))
      const month = Number(date.substr(5, 2)) - 1
      const day = Number(date.substr(8, 2))
      return new Date(year, month, day)
    },
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toEstimateDetail () {
      this.currentState = IS_ESTIMATE_DETAIL
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_KEKKA_SHOSAI', 'TAP')
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackStartPreferred () {
      this.nativeEVENTSet('ShakenKekkaButton', 'MOVED_SHAKEN_YOYAKU', 'TAP')
    },
    openErrorModal (message) {
      modal.alert(message)
    }
  },
  computed: {
    ...mapGetters('PRICE', [
      'price'
    ]),
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isEstimateDetail () {
      return this.currentState === IS_ESTIMATE_DETAIL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    taxPrice: function () {
      // 車検基本料、定額整備費用＋エンジンオイル不要割＋クーポン料金
      let price = (this.price.price.base_price + this.price.price.oil_exchanged_fee + this.price.coupon_fee)
      // 消費税率を掛ける
      price = Math.round(price * this.taxRate() * 10)
      price = price / 10
      // 1 + 消費税率を割る
      price = Math.round(price / (1 + this.taxRate()) * 10)
      price = price / 10
      return price
    }
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    let isApiError = false

    // 見積り金額計算API
    await price.post(this.$route.params.car).then(res => {
      this.setPrice(res.data)
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 車検満了日、初度登録年月の和暦を取得する。
    this.expiryOnWareki = this.toWareki(this.$route.params.car.expiry_on)
    this.firstRegistrationOnWareki = this.toWareki(this.$route.params.car.first_registration_on + '-01')
    // APIから自動車の種別、車名（メーカー）を取得する。
    await carTypeApi.getDetail(this.$route.params.car.model_code).then(res => {
      this.carType = res.data.car_type
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    await manufacturersApi.getDetail(this.$route.params.car.manufacturer_id).then(res => {
      this.Manufacturer = res.data.manufacturer
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // 現在時刻から半年後の時間変数を作成
    this.sixMonthLater = moment().add(6, 'months').toDate()
    // 比較用に車検満了日をDate型に変換
    this.expiryOnDate = this.dateParse(this.$route.params.car.expiry_on)
    // [eventTrack] 車検見積り 画面表示完了
    this.nativePVset('SHAKEN_MITSUMORI_KEKKA')
    if (!isApiError) {
      this.loading = false
    }
  },
  data () {
    return {
      loading: true,
      expiryOnWareki: {},
      firstRegistrationOnWareki: {},
      carType: {},
      Manufacturer: {},
      sixMonthLater: '',
      expiryOnDate: '',
      currentState: IS_INITIAL
    }
  },
  components: {
    EstimateDetailBefore,
    Agreement,
    Lease,
    Loading
  }
}

</script>

<style></style>
